import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

// @ts-ignore
import BillingPlanCard from '@/components/Billing/BillingPlanCard.vue';
import BillingService from '@/components/Billing/billing-service';
import { Plan } from '@/components/Billing/billing-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingPlanCardDataProvider',
  props: {
    plan: null,
    activePlan: null,
    selectedPlan: null,
    virtuallyUnlimitedPlan: null,
    isCurrentTeamTasksVirtuallyUnlimited: { type: Boolean },
    currentAccountCustomerFeatureQuantity: null
  },
  emits: ["select-plan", "update-customer-features-tasks-quantity"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'select-plan', planId: string): void;
	(e: 'update-customer-features-tasks-quantity', customerFeaturesTasksQuantity: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	plan: Plan;
	activePlan: string;
	selectedPlan: string;
	virtuallyUnlimitedPlan?: Plan;
	isCurrentTeamTasksVirtuallyUnlimited?: boolean;
	currentAccountCustomerFeatureQuantity?: number;
}



const isActive = computed(() => props.plan.refId === props.activePlan || props.virtuallyUnlimitedPlan?.refId === props.activePlan);
const isSelected = computed(() => props.plan.refId === props.selectedPlan || props.virtuallyUnlimitedPlan?.refId === props.selectedPlan);
const showVirtuallyUnlimitedPlan = ref(
	props.virtuallyUnlimitedPlan ? Boolean(props.isCurrentTeamTasksVirtuallyUnlimited && isActive.value) : false
);
const planToShow = computed(() => {
	const plan = showVirtuallyUnlimitedPlan.value ? props.virtuallyUnlimitedPlan : props.plan;
	if (!plan) {
		throw new Error('Plan not found');
	}
	return plan;
});
const planDescriptions = computed(() => BillingService.getPlanDescriptions(planToShow.value));
const descriptionsTitle = computed(() => BillingService.getPlanDescriptionsTitle(planToShow.value));

return { __sfc: true,emit, props, isActive, isSelected, showVirtuallyUnlimitedPlan, planToShow, planDescriptions, descriptionsTitle, BillingPlanCard }
}

})